module.exports = __webpack_public_path__ + "media/images/youtube-icon-292fd7b13ce7b673465dd9f6728d3829.png";